import { RouteObject } from "react-router-dom";
import { complaintRoutes } from "./complaints";
import { consumerOnboardingRoutes } from "./consumer-onboarding";
import { dashboardRoutes } from "./cxDashboard/routes";

import { consumerManagementRoutes } from "./consumerManagement";
import { disconnectionRoutes } from "./disconnect/routes";
import { outstandingRoutes } from "./outstanding";
import { paymentRoutes } from "./paymentsv2";
import { reconnectionRoutes } from "./reconnect/routes";
import { cxSelfServiceRoutes } from "./selfService";
import { serviceRoutes } from "./services";
import { cxSettingsRoutes } from "./settings/routes";
import { transferRoutes } from "./transfer/routes";
export interface CXRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: CXRoute[];
}
export const cxRoutes: CXRoute[] = [
  ...cxSettingsRoutes,
  ...disconnectionRoutes,
  ...reconnectionRoutes,
  ...complaintRoutes,
  ...dashboardRoutes,
  ...consumerOnboardingRoutes,
  ...consumerManagementRoutes,
  ...paymentRoutes,
  ...serviceRoutes,
  ...outstandingRoutes,
  ...reconnectionRoutes,
  ...transferRoutes,
  ...cxSelfServiceRoutes,
];
